import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { localize } from 'react-localize-redux';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import i18n from '../translations/i18n';

const propTypes = {
  content: PropTypes.object,
  title: PropTypes.string,
  onChange: PropTypes.any,
  lang: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {};

const ActionText = (props) => {
  function fieldChange(event, newValue) {
    const action = props.content;
    action.value = newValue;
    props.onChange(action);
  }

  if ((!props.content && !props.lang) || props.content.language !== props.lang) {
    return null;
  }

  return (
    <TextField
      label={props.content.action}
      defaultValue={props.content.value}
      id={props.content.action}
      name="action"
      fullWidth
      floatingLabelText={props.content.action}
      floatingLabelFixed
      onChange={(event, value) => fieldChange(event, value)}
      multiLine
    />
  );
};

ActionText.propTypes = propTypes;
ActionText.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(ActionText);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/ActionText.js